/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderCreateCargo } from './order_create_cargo'
import type { OrderCreateCargoTotal } from './order_create_cargo_total'
/**
 * Информация о грузе
 */
export type OrderCreateCargoInfo = {
  /**
   * Способ указания информации о грузе
   */
  type: OrderCreateCargoInfo.type
  /**
   * Грузоместа
   */
  separate?: Array<OrderCreateCargo>
  /**
   * Информация о грузе в виде общего веса и объема
   */
  total?: OrderCreateCargoTotal
}
export namespace OrderCreateCargoInfo {
  /**
   * Способ указания информации о грузе
   */
  export enum type {
    SEPARATE = 'separate',
    TOTAL = 'total'
  }
}
